















































































































import { Component, Watch, Vue, Prop, Emit } from 'vue-property-decorator'; // デコレータ
// 共通機能
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
// 定数ファイル
import { Constants } from '../../CommonUtils/fixed/Constants';
import { UketsukeConstants } from '../fixed/UketsukeConstants';
import { UketsukeScreenName } from '../fixed/UketsukeScreenName';
// 共通モジュール
import { supervisingModule } from '../../store/modules/OperationSupervising';
import { routingControlModule } from '@/store/modules/RoutingControl';
import { applicationFormModule } from '../store/modules/ApplicationForm';

// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class ApplicationReviewStatus extends ApiAccessBase {

  private isMaxRevNo: string = '';
  private isRevNo: string = '';
  private isSubmitDay: string = '';

  // 共通パス
  private APP_PATH = UketsukeConstants.UKETSUKE_URL + '/review';

  private created() {
    this.screenTitle = '審査状況';
    // モジュールに現在の画面を記録
    routingControlModule.registCurrent(this.$route.name);

    let path = this.APP_PATH;
    path = path + '/get/' + applicationFormModule.GET_APP_TYPE;
    path = path + '/' + applicationFormModule.GET_TRADER_ID;
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        //使用する可変項目の設定（全て）
        this.setAllVariablecolsState();
        // 履歴番号と提出日の設定
        this.isMaxRevNo = this.formData.revision_no[0];
        this.isRevNo = this.formData.revision_no[0];
        this.isSubmitDay = this.formData.submit_day[0];
      }
    });
  }

  /**
   * 登録
   */
  private regist() {
    // form成形
    this.moldingSendForm(this.$refs.form);
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      const errorBag: any = this.getFormErrorData(this.$refs.form);
      for (const error of Object.keys(errorBag)) {
        if (errorBag[error]) {
          if (this.focusElement('input-' + error) ) {
            break;
          }
        }
      }
      return;
    }

    let path = this.APP_PATH;
    path = path + '/put/' + applicationFormModule.GET_APP_TYPE;
    path = path + '/' + applicationFormModule.GET_TRADER_ID;
    path = path + '/' + this.isMaxRevNo;
    let successMessage = '';
    this.apiAccess(path, Constants.API_METHOD_POST, false, false).then(
      (result) => {
        if ((result) === Constants.API_RESULT_SUCCES) {
          //再取得前に完了メッセージを一時格納する
          successMessage = this.infoMessage;
          //更新後のデータを再取得する
          this.getReviewStatus(this.isMaxRevNo);
          this.infoMessage = successMessage;
        }
      },
    );
    // 先頭へジャンプ
    this.hrefElement('applicationReviewStatus', -50);
  }

  /**
   * 前画面に戻る
   */
  private returnPrevious() {
    //排他の解除
    let path = this.APP_PATH;
    path = path + '/exclusive/delete/' + applicationFormModule.GET_APP_TYPE;
    path = path + '/' + applicationFormModule.GET_TRADER_ID;
    this.apiAccess(path, Constants.API_METHOD_POST, false, true)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        // 前画面に戻る
        router.push({name: UketsukeScreenName.APP_TRADER_SEARCH});
      }
    });
  }

  /**
   * 次の審査状況履歴番号を設定して取得処理を実行する
   */
  private nextReview() {
    this.getReviewStatus(String(Number(this.isRevNo) + 1));
  }

  /**
   * 前の審査状況履歴番号を設定して取得処理を実行する
   */
  private prevReview() {
    this.getReviewStatus(String(Number(this.isRevNo) - 1));
  }

  /**
   * 引数に設定した履歴番号から審査状況を取得
   */
  private getReviewStatus(nextRevNo: string) {
    let path = this.APP_PATH;
    path = path + '/revisionget/' + applicationFormModule.GET_APP_TYPE;
    path = path + '/' + applicationFormModule.GET_TRADER_ID;
    path = path + '/' + nextRevNo + '/' + this.isMaxRevNo;
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false)
    .then((result) => {
        if (result === Constants.API_RESULT_SUCCES) {
          //使用する可変項目の設定（全て）
          this.setAllVariablecolsState();
          // 履歴番号と提出日の更新
          this.isRevNo = this.formData.revision_no[0];
          this.isSubmitDay = this.formData.submit_day[0];
        }
      });
    // 先頭へジャンプ
    this.hrefElement('applicationReviewStatus', -50);
  }
}
